import { getCurrentSubscription } from "@syla/shared/types/helpers/subscriptions";
import { useState } from "react";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { useQueryGetAccount } from "../../../store/useQueryGetAccount";
import { useQueryGetPlans } from "../../../store/useQueryGetPlans";

import { useQuerySubscriptions } from "../../../store/useQuerySubscriptions";

export function useAccountSubscriptionData() {
  const [redirecting, setRedirecting] = useState<boolean>(false);
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const {
    data: subscriptions,
    isLoading: subscriptionsLoading,
    error: subscriptionsError,
  } = useQuerySubscriptions();

  const {
    data: account,
    isLoading: accountLoading,
    error: accountError,
  } = useQueryGetAccount(accountId);

  const {
    data: plansData,
    isLoading: isPlansLoading,
    error: plansError,
  } = useQueryGetPlans();

  const subscription =
    subscriptions ?
      getCurrentSubscription(subscriptions.subscriptions)
    : undefined;

  const downgradePlan = plansData?.plans.find(
    (plan) => plan._id.toString() === subscription?.downgradeToPlan?.toString(),
  );

  const isLoading = subscriptionsLoading || accountLoading || isPlansLoading;
  const hasError = subscriptionsError || accountError || plansError;
  const hasData = subscription && account && plansData;

  return {
    // data
    subscription,
    account,
    plans: plansData,
    downgradePlan,

    // state
    redirecting,
    setRedirecting,

    // status
    isLoading,
    hasError,
    hasData,

    // individual errors for specific error handling if needed
    subscriptionsError,
    accountError,
    plansError,
  };
}
